import Utils from "@/services/utils";
import OneClickService from "@/services/payment/oneClick";
import { isConfirmationPagePath } from "@/services/confirmationTemplateUpgrade";
import { bindOrderPageNavbarScroll } from "@/services/orderPageNavbarScroll";
import { notifyOrderPageContextReady } from "@/services/orderPageScope";

// All methods that will execute when app is fully mounted
document.addEventListener("vue-app-mounted", () => {
  notifyOrderPageContextReady();
  Utils.handleConditionedContent();
  Utils.addConditionedContentListener();
  if (isConfirmationPagePath()) {
    bindOrderPageNavbarScroll();
  }
  if (
    window.globalConfig?.scriptAvisVerifies &&
    (window.productDetails || window.productList)
  ) {
    Utils.insertScript(window.globalConfig.scriptAvisVerifies);
  }
  const scriptGalileo = document.head.querySelector(
    'script[src="/technical/search/index.min.js"]',
  );
  if (!scriptGalileo) {
    Utils.insertScript("/technical/search/index.min.js");
  }

  const addChoices = OneClickService.shouldHandleOneClick();
  if (addChoices) {
    OneClickService.processOneClick(addChoices).catch((error) => {
      console.error("[OneClick] mounted: process failed", error);
      OneClickService.stopOneClickProcessing();
    });
  } else {
    OneClickService.stopOneClickProcessing();
  }
});
